import Vue from 'vue'
import Router from 'vue-router'
import Product from '@/components/Product'
import ProductDesk from '@/components/Product/Desk'
import Cart from '@/components/Cart'
import Checkout from '@/components/Checkout'
import Order from '@/components/Order'
import Pay from '@/components/Pay'
import MyTrade from '@/components/My/Trade'
import Sso from '@/components/Sso'
import MyDashboard from '@/components/My/Dashboard'
import MyOrder from '@/components/My/Order'
import MyConfirm from '@/components/My/Confirm'
import inAppSpeed from '@/components/inApp/Speed'
import inAppSso from '@/components/inApp/Sso'
import inAppDevices from '@/components/inApp/Devices'
import inAppTrade from '@/components/inApp/Trade'
import inAppMember from '@/components/inApp/Member'
import inAppVodLayout from '@/components/inApp/Vod/Layout'
import inAppVodHome from '@/components/inApp/Vod/Home'
import inAppVodLive from '@/components/inApp/Vod/Live'
import inAppVodDetail from '@/components/inApp/Vod/Detail'
import inAppVodResult from '@/components/inApp/Vod/Result'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Layout',
      component: ProductDesk
    },
    {
      path: '/desk',
      name: 'Desk',
      component: ProductDesk
    },
    {
      path: '/box',
      name: 'Box',
      component: Product
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/checkout',
      name: 'Checkout',
      component: Checkout
    },
    {
      path: '/order/:ticket_id',
      name: 'Order',
      component: Order
    },
    {
      path: '/pay/:ticket_id',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/sso/:token',
      name: 'Sso',
      component: Sso
    },
    {
      path: '/my/dashboard',
      name: 'MyDashboard',
      component: MyDashboard
    },
    {
      path: '/my/order',
      name: 'MyOrder',
      component: MyOrder
    },
    {
      path: '/my/trade/:trade_id',
      name: 'MyTrade',
      component: MyTrade
    },
    {
      path: '/my/confirm/:email',
      name: 'MyConfirm',
      component: MyConfirm
    },
    {
      path: '/in-app/speed',
      name: 'inAppSpeed',
      component: inAppSpeed
    },
    {
      path: '/in-app/sso',
      name: 'inAppSso',
      component: inAppSso
    },
    {
      path: '/in-app/devices',
      name: 'inAppDevices',
      component: inAppDevices
    },
    {
      path: '/in-app/trade/pay',
      name: 'inAppTrade',
      component: inAppTrade
    },
    {
      path: '/in-app/member',
      name: 'inAppMember',
      component: inAppMember
    },
    {
      path: '/in-app/vod',
      name: 'inAppVodHome',
      component: inAppVodLayout,
      children: [
        {
          path: '/in-app/vod/home',
          name: 'inAppVodHome',
          component: inAppVodHome
        },
        {
          path: '/in-app/vod/live',
          name: 'inAppVodLive',
          component: inAppVodLive
        },
        {
          path: '/in-app/vod/result/:keyword',
          name: 'inAppVodResult',
          component: inAppVodResult
        },
        {
          path: '/in-app/vod/result/:keyword/:acc',
          name: 'inAppVodResult',
          component: inAppVodResult
        },
        {
          path: '/in-app/vod/detail/:skey/:vid',
          name: 'inAppVodDetail',
          component: inAppVodDetail
        }
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js